"use client";
import Link from "next/link";
import Image from "next/image";
import CTABannerImg from "@/Helper/images/new/cta_bxinnerrightimg.png";
const CTAHome = () => {
  return (
    <div className="home_ctaouter">
       <div className="container">
          <div className="cta_bxouter">
            <div className="cta_bxinner">
              
              <div className="wrk_plleft cta_bxinnerleft">
              <p className="wrk_plheading">Join Us!</p>
              <p className="wrk_plcontent">
              Whether it's our flexible shafts or our dynamic team, we're stronger together</p>
              <div className="viewbtn">
                <Link href="/careers" className="btn btn-primary">
                  Careers<span className="right_arrowcontact1"></span>
                </Link>
              </div>
            </div>
              <div className="cta_bxinnerright">
              <Image src={CTABannerImg} alt="Join us and Grow your business" />
              </div>
            </div>
          </div>
       </div>
    </div>
  );
};

export default CTAHome;
